<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Search Training Records
							</div>
				
							<div class="page_main">
								<el-form :model="query" label-position="top" class="search-form">
									<div class="form-grid">
				
										<!-- Left -->
										<div class="form-col">
				
											<el-form-item label="Name">
												<el-input
													v-model="query.title"
													placeholder="Please enter"
													clearable
												/>
											</el-form-item>
				
											<el-form-item label="Description">
												<el-input
													v-model="query.description"
													placeholder="Please enter"
													clearable
												/>
											</el-form-item>
				
										</div>
				
										<!-- Right -->
										<div class="form-col">
				
											<el-form-item label="Creation Date">
												<el-date-picker
													v-model="time"
													type="datetimerange"
													@change="getTime"
													range-separator="to"
													start-placeholder="Select start date"
													end-placeholder="Select end date"
													class="full-width"
													:default-time="['00:00:00', '23:59:59']"
												>
												</el-date-picker>
											</el-form-item>
				
										</div>
				
									</div>
				
									<div class="search-btn-wrap">
										<el-button type="primary" @click="handleSearch">
											Search
										</el-button>
									</div>
								</el-form>
				
								<!-- Table -->
								<div class="file-panel">
				
									<div class="panel-header">
										<div></div>
				
										<el-input
											v-model="keyword"
											placeholder="Search"
											clearable
											class="search-input"
										>
											<i slot="prefix" class="el-input__icon el-icon-search"></i>
										</el-input>
				
									</div>
				
									<el-table
										:data="trainTableData"
										border
										class="file-table"
										header-cell-class-name="table-header-cell"
									>
				
										<el-table-column
											label="Action"
											width="180"
											align="center"
											fixed="left"
										>
											<template slot-scope="scope">
												<el-button
													type="primary"
													size="mini"
													@click="handleManage(scope.row)"
												>
													Manage Training
												</el-button>
											</template>
										</el-table-column>
				
										<el-table-column
											prop="title"
											label="Name"
											min-width="150"
											sortable
											show-overflow-tooltip
										/>
				
										<el-table-column
											prop="description"
											label="Description"
											min-width="200"
											sortable
											show-overflow-tooltip
										/>
				
										<el-table-column
											label="Action"
											width="80"
											align="center"
											fixed="right"
										>
											<template slot-scope="scope">
												<el-link
													type="primary"
													size="mini"
													@click="handleInfo(scope.row)"
												>
													Details
												</el-link>
											</template>
										</el-table-column>
				
									</el-table>
				
									<div class="pagination">
										<el-pagination
											@size-change="handleSizeChange"
											@current-change="handlePageChange"
											:current-page="query.page"
											:page-sizes="[5, 10, 20, 50]"
											:page-size="query.page_size"
											layout="total, sizes, prev, pager, next"
											:total="pageTotal"
										>
										</el-pagination>
									</div>
				
								</div>
								<!-- Table -->
				
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!-- loading -->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
	</div>
</template>

<script>
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import {
		trainRecordList
	} from "@/api/trainManage/configTrain/trainRecord/index";
	import moment from "moment";
	moment.locale("zh-cn");
	export default {
		components: {
			headers,
			slider,
		},
		data() {
			return {
				isLoading: true,
				keyword: "",
				query: {
					title: "",
					description: "",
					time1: "",
					time2: "",
					page: 1,
					page_size: 10,
				},
				time: "",
				tableData: [],
				pageTotal: 0,
			};
		},
		created() {
			let that = this;
		},
		mounted() {
			let that = this;
			that.isLoading = false;
			that.getTableData();
		},
		computed: {
			trainTableData() {
				return this.filterTableData(this.tableData, this.keyword);
			},
		},
		methods: {
			filterTableData(source, keyword) {
				if (!keyword || !keyword.trim()) return source;
				const lowerKeyword = keyword.toLowerCase().trim();
				return source.filter((item) => {
					const text = this.flattenValues(item).toLowerCase();
					return text.includes(lowerKeyword);
				});
			},
			flattenValues(data) {
				if (data === null || data === undefined) return "";
				if (Array.isArray(data)) {
					return data.map((item) => this.flattenValues(item)).join(" ");
				}
				if (typeof data === "object") {
					return Object.values(data)
						.map((val) => this.flattenValues(val))
						.join(" ");
				}
				return String(data);
			},
			getTableData() {
				let that = this;
				that.tableLoading = true;
				trainRecordList(that.query).then((res) => {
					that.tableLoading = false;
					if (res.code == 200) {
						that.tableData = res.data.data;
					}
				});
			},
			//时间格式化
			dateFormat: function(row, column) {
				let that = this;
				var date = row[column.property];
				if (date == undefined || date == 0) {
					return "/";
				}
				return moment(date * 1000).format("YYYY-MM-DD");
			},
			//时间选择变化
			getTime(date) {
				let that = this;
				if (date) {
					that.query.create_start = moment(date[0]).format("YYYY-MM-DD HH:mm:ss");
					that.query.create_end = moment(date[1]).format("YYYY-MM-DD HH:mm:ss");
				} else {
					that.query.create_start = "";
					that.query.create_end = "";
				}
			},
			handleSearch() {
				let that = this;
				that.query.page = 1;
				that.getTableData();
			},
			//清空搜索项
			clearSearch() {
				let that = this;
				that.query = {
					name: "",
					description: "",
					page: 1,
					page_size: 10,
				};
				that.time = null;
				that.getTableData();
			},
			//条数选择
			handleSizeChange(value) {
				let that = this;
				that.query.page_size = value;
				that.getTableData();
			},
			//页数跳转
			handlePageChange(value) {
				let that = this;
				that.query.page = value;
				that.getTableData();
			},
			handleManage(row) {
				let that = this;
				that.$router.push({
					path: "/TrainControl/manage-train",
					query: {
						type: "demand",
						recordId: row.id,
						recordName: encodeURIComponent(row.title),
					},
				});
			},
			handleInfo(value) {
				let that = this;
				const routeData = that.$router.resolve({
					path: '/TrainControl/archival-detail',
					query: {
						id: value.id
					}
				});
				window.open(routeData.href, "_blank");
			},
			//跳转页面
			goUrl(url) {
				let that = this;
				that.$router.push(url);
			},
		},
	};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 24px;
		align-items: start;
	}

	.form-grid .el-form-item {
		margin-bottom: 0;
	}

	.full-width {
		width: 100%;
	}

	.input-btn-group {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.input-btn-group .el-input {
		flex: 1;
	}

	.search-btn-wrap {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 20px 0 16px;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 40px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	.pagination {
		margin: 10px 0;
		text-align: right;
	}

	::v-deep .el-form-item__label {
		font-size: 16px;
		color: #222;
		font-weight: 700;
		padding-bottom: 8px;
		position: relative;
	}

	::v-deep .el-input__inner,
	::v-deep .el-textarea__inner {
		border-radius: 4px;
	}

	@media (max-width: 1200px) {
		.form-grid {
			grid-template-columns: 1fr;
		}
	}

	::v-deep .el-button {
		border-radius: 6px;
	}

	::v-deep .btn span {
		text-decoration: underline;
	}

	::v-deep .form-grid .el-form-item__label {
		padding-bottom: 0;
	}
</style>